import { t } from 'ttag';

// This widget has no backend record, hence the sentinel id. Kept out of
// WIDGET_ENTITY_TYPE, which drives the Add Widget menu and the type filter.
export const REG_FORM_WIDGET_ID = 'reg-form';
export const REG_FORM_WIDGET_TYPE = 'registration';

// The row the list API can't give us.
export const getRegFormWidgetRow = () => ({
  id: REG_FORM_WIDGET_ID,
  name: t`Registration Form`,
  contentEntityType: REG_FORM_WIDGET_TYPE,
});
